export function validateCharactersLv (value: string) {
  const rule = /^[a-zA-ZāčēģīķļūžņšŠŅĀČĒĢĪĶĻŪŽ0-9/\\*@£$%&(){}\[\]^;:.,´_!?~<>|§#¤=+€\s-\"']*$/;

  return rule.exec(value) != null;
}
